const storeInfo = { 
}

function attachStore( store, storeName = 'default' ) {
  if ( storeInfo[storeName] == null ) {
    const unsubscribe = store.subscribe( ( ) => {
      storeInfo[storeName].state = store.getState()
    } )
    storeInfo[storeName] = { store, state : store.getState(), unsubscribe }
  } else {
    throw Error( `GlobalState.attachStore() : Store named ${storeName} already exists` )
  }
}

function detachStore( storeName ) {
  if ( storeInfo[storeName] ) {
    storeInfo[storeName].unsubscribe()
    delete storeInfo[storeName]
  } else {
    throw Error( `GlobalState.detachStore() : Store named ${storeName} does not exist` )
  }
}

function get( storeName = 'default' ) { 
  if ( storeInfo[storeName] ) {
    return storeInfo[storeName].state
  }
  throw Error( `GlobalState.get() : Store named ${storeName} does not exist` )
}

function dispatch( action, storeName = 'default' ) { 
  if ( storeInfo[storeName] ) {
    return storeInfo[storeName].store.dispatch( action )
  }
  throw Error( `GlobalState.dispatch() : Store named ${storeName} does not exist` )
}

export default {
  attachStore,
  detachStore,
  get,
  dispatch
}
